import * as Factory from 'factory.ts'
import faker from 'faker'

import { type SavedFilter } from '@webapp/models/SavedFilter'
import { FilterTagMock } from './filtertag.factory'
import { UserMock } from './user.factory'

export const SavedFilterMock = Factory.Sync.makeFactory<SavedFilter>({
  id: Factory.each(() => faker.random.number()),
  filters: FilterTagMock.buildList(3).reduce((prev, curr) => {
    prev[curr.key] = { id: curr.value, name: curr.label }
    return prev
  }, {}),
  collection: 'pay.approvals',
  user: UserMock.build().id,
  name: Factory.each(() => faker.lorem.words()),
})
